import { useState } from "react";
import { useData } from "../../../context/GetDataContext";
import { useModal } from "../../../hooks/useModal";
import MuiModelTab from "../../Mui/model/MuiModelTab";
import { useUpdateForm } from "../../../context/UpdateFormContext";

interface props {
  source: any;
  dispatch?: any;
}

const LoadDispatch = ({ source, dispatch }: props) => {
  const { isOpen, openModal, closeModal } = useModal();
  const { data } = useData();
  const [formTitle, setFormTitle] = useState("");
  const [popFormId, setPopFormId] = useState("");
  const [formAction, setFormAction] = useState("");
  const [id, setId] = useState<Number | null>(null);

  return (
    <>
      {dispatch ? (
        <div className="border p-2  flex justify-between">
          <div className="flex gap-3 text-xs">
            <div>
              <strong>Vehicle</strong> <br />
              {dispatch?.trailer?.number
                ? dispatch?.trailer?.number
                : data?.dispatch?.vehicle_number}
            </div>
            <div>
              <strong>Trailer</strong> <br />
              {dispatch?.vehicle?.number
                ? dispatch?.vehicle?.number
                : data?.dispatch?.trailer_number}
            </div>
            <div>
              <strong>Driver</strong> <br />
              {dispatch?.driver?.first_name
                ? dispatch?.driver?.first_name +
                  " " +
                  dispatch?.driver?.last_name
                : data?.dispatch?.driver_name}
            </div>
          </div>
          <div className="flex gap-1 text-sm">
            <button
              className="rounded-full bg-indigo-500 text-white px-2.5"
              onClick={() => {
                openModal();
                setFormAction("edit");
                setFormTitle("Dispatch Load");
                setPopFormId("loadDispatch");
                setId(data?.dispatch?.id);
              }}
              // onClick={() => {
              //   handleClick({
              //     formId: "loadDispatch",
              //     sectionId: null,
              //     action: "edit",
              //     id: data?.dispatch?.id,
              //     title: "Load Dispatch",
              //   });
              // }}
            >
              <i className="fa-solid fa-edit"></i>
            </button>
            <button className="rounded-full bg-indigo-500 text-white px-2.5">
              <i className="fa-solid fa-envelope"></i>
            </button>
            <button className="rounded-full bg-green-500 text-white  px-2.5">
              <i className="fa-brands fa-whatsapp"></i>
            </button>
            <button className="rounded-full bg-red-500 text-white  px-2.5">
              <i className="fa-solid fa-comment-sms"></i>
            </button>
          </div>
        </div>
      ) : (
        <div className="flex space-x-1 mb-2 mt-2">
          <button
            onClick={() => {
              openModal();
              setFormTitle("Dispatch Load");
              setPopFormId("loadDispatch");
            }}
            className="bg-blue-500 text-white px-2 py-2 rounded text-xs"
          >
            Dispatch Load
          </button>
          <button
            className="bg-blue-500 text-white px-2 py-2 rounded text-xs"
            onClick={() => {
              openModal();
              setFormTitle("Broker Load");
              setPopFormId("loadBroker");
            }}
          >
            Broker Load
          </button>
          <button className="bg-blue-500 text-white px-2 py-2 rounded text-xs">
            Assign To LTL Trip
          </button>
          <button className="bg-blue-500 text-white px-2 py-2 rounded text-xs">
            Assign To Local Trip
          </button>
          <button className="bg-green-500 text-white px-2 py-2 rounded text-xs">
            Create
          </button>
        </div>
      )}

      <MuiModelTab
        isOpen={isOpen}
        onClose={closeModal}
        formId={popFormId}
        source={source}
        title={formTitle}
        crudOp={{
          id: id,
          action: formAction,
        }}
      />
    </>
  );
};

export default LoadDispatch;
